{"windView":"2026.12","buildNumber":"16119","ngxShared":"1.59.6","ndtCanvas":"1.59.6","sharedBusiness":"1.59.6","sharedModulesAngular":"1.59.6"}